import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import lineService from "../../services/line-service";
import palmService from "../../services/palm-service";
import { Link, useNavigate } from "react-router-dom";
import { Divider, Spin, Modal, Pagination } from "antd";
import { ToastContainer, toast } from 'react-toastify';
import reportServices from "../../services/report-services";
import Swal from "sweetalert2";

const AdminLines = () => {


  ///paginacion
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [loadingMovements, setLoadingMovements] = useState(false);
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [total, setTotal] = useState(0);
  const [initReport, setInitReport] = useState(false);


  const [isModalOpen, setIsModalOpen] = useState(false);
  const [movements, setMovements] = useState([]);
  const [selectedPalm, setSelectedPalm] = useState(null);


  let navigate = useNavigate();
  const [showDivPalms, setShowDivPalms] = useState(true);
  const [newLines, setNewLines] = useState([]);
  const [listLines, setListLines] = useState([]);
  const [lotName, setLotName] = useState("");
  const [lineName, setLineName] = useState("");
  const [listPalms, setListPalms] = useState([]);
  const [title, setTitle] = useState("");
  const [sessionUser, setSessionUser] = useState("admin");

  const [linesCount, setLinesCount] = useState(0);

  const {
    register,
    handleSubmit,
    setValue,
    getValues,
    formState: { errors },
  } = useForm();

  const optionsState = [
    { id: true, name: "ACTIVO" },
    { id: false, name: "INACTIVO" },
  ];



  ///PAGINACION MOVIMIENTOS PLANTA/////


  const getListByPalm = async (palm) => {
    setInitReport(true)
    setLoadingMovements(true);
    try {
      const palmId = palm._id;
      localStorage.setItem("palmId", palmId);
      const lotId = localStorage.getItem("lotId");
      const sectionId = localStorage.getItem("sectionId");
      const farmId = localStorage.getItem("farmId");
      const initPage = 1
      setPage(1)
      const response = await reportServices.palmMovements(initPage, pageSize, farmId, sectionId, lotId, palmId);
      setMovements(response.data);
      setTotal(response.total);
    } catch (error) {
      console.error("Error al obtener los movimientos:", error);
    } finally {
      setLoadingMovements(false);
    }

    const dummyMovements = [
      { date: "2025-04-26", activity: "Riego", operator: "Juan" },
      { date: "2025-04-27", activity: "Fertilización", operator: "Pedro" },
    ];

    setSelectedPalm(palm);         // para saber de qué palma estamos viendo movimientos
    //setMovements(dummyMovements);  // reemplaza esto cuando tengas servicio real
    setIsModalOpen(true);
  };


  const generateExcel = async () => {


    setIsModalOpen(false);
  }



  const handlePageChange = (page, pageSize) => {
    setPage(page);
    setPageSize(pageSize);
  };

  const fetchMovements = async (page, pageSize) => {

    if (!initReport) {
      console.log("no ha iniciado una consulta por palma")
      return;
    }

    setLoadingMovements(true);
    try {
      const lotId = localStorage.getItem("lotId");
      const palmId = localStorage.getItem("palmId");
      const sectionId = localStorage.getItem("sectionId");
      const farmId = localStorage.getItem("farmId");
      const response = await reportServices.palmMovements(page, pageSize, farmId, sectionId, lotId, palmId);
      setMovements(response.data);
      setTotal(response.total);
    } catch (error) {
      console.error("Error al obtener los movimientos:", error);
    } finally {
      setLoadingMovements(false);
    }
  };
















  const ingresarLinea = async (e) => {
    const name = parseInt(getValues("name"));
    const lotId = localStorage.getItem("lotId");
    const farmId = localStorage.getItem("farmId");

    const data = { lotId, farmId, name };
    await lineService.insertLine(data);
    toast('Realizado.', { autoClose: 1000 });
    await getListLines(lotId);



  };

  const handleInputChange = (id, value) => {
    setNewLines((prevRows) =>
      prevRows.map((row) => (row.id === id ? { ...row, palms: value } : row))
    );
  };

  const addPalm = (line) => {
    localStorage.setItem("lineId", line._id);
    localStorage.setItem("lineName", line.name);
    navigate("/admin-palms");
  };

  ////FUNCIONES QUE USAN EL SERVICIO LINE-SERVICE
  ////FUNCIONES QUE USAN EL SERVICIO LINE-SERVICE




  const getListByLine = async (line) => {
    setLoading(true)
    setLineName(line.name)
    const listado = await palmService.getListByLine(line._id);
    const quantity = listado.length + 1;
    //setValue("name", quantity);
    setListPalms(listado);
    setLoading(false)

    window.scrollTo({ top: 0, behavior: "smooth" });
  };


  const getListLines = async (lotId) => {
    const listado = await lineService.getList(lotId);
    if (listado) {
      /*const sortedList = [...listado].sort((a, b) => {
        const numA = parseInt(a.name.replace(/\D/g, ""), 10);
        const numB = parseInt(b.name.replace(/\D/g, ""), 10);
        return numA - numB;
      });*/

      setLinesCount(listado.length)

      setListLines(listado);
    }








  };






  const deleteLine = async (id, lineName) => {
    const username = localStorage.getItem("username");
    if (username != "superadmin") {
      toast.error('Usuario sin privilegios de edición.', { autoClose: 1000 });
      return;
    }
    else {
      Swal.fire({
        title: `Eliminar  línea`,
        html: `Desea eliminar la ${lineName} y sus palmas? <br/> <em>(Solo puede eliminar lineas sin tareas asociadas)</em> `,
        showDenyButton: false,
        showCancelButton: true,
        confirmButtonText: "Eliminar",
        denyButtonText: `Conservar`
      }).then(async (result) => {
        if (result.isConfirmed) {
          setLoading(true)
          const data = { id };
          const response = await lineService.deleteLine(data);
          console.log(response)
          if (response.success) {
            loadLines();
            toast(response.message, { autoClose: 1000 });
          }
          else {
            toast.error(response.error, { autoClose: 1000 });
          }
          setLoading(false)
        }
      });
    }
  }



  const loadLines = () => {
    const lot_id = localStorage.getItem("lotId");
    getListLines(lot_id);
  }


  useEffect(() => {
    const lot_id = localStorage.getItem("lotId");
    const lot_name = localStorage.getItem("lotName");
    const username = localStorage.getItem("username");
    setSessionUser(username)

    setValue("lotId", lot_id);
    setValue("lotName", lot_name);
    setLotName(lot_name);
    getListLines(lot_id);
    fetchMovements(page, pageSize);

    const farm_name = localStorage.getItem("farmName");
    setTitle(`${farm_name} - ${lot_name}`);

  }, [page, pageSize]);




  return (
    <div className="row p-4">
      <ToastContainer />

      <div className="col-12 " style={{ marginTop: "-10px" }}>
        <Divider
          orientation="left"
          style={{
            borderColor: "#AAAAAA"
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "10px"
            }}
          >
            <span>FINCA: {title}</span>

            <Link
              to="/admin-lots"
              className="nav-link link-primary p-1"
            >
              <i className="bi bi-arrow-left-short fa-lg"></i>

              <span className="fs-6 m-1">
                <strong>
                  REGRESAR A LOTES
                </strong>
              </span>
            </Link>
          </div>
        </Divider>
      </div>





      <div className="col-12 col-sm-3">
        <div className="card p-4">
          <form className="form-react">
            <div className="row">
              <div className="card-title">
                <h4 className="text-secondary" >Agregar línea</h4>
              </div>

              <div className=" col-12 d-none">
                <label>LotId</label>
                <input
                  readOnly={true}
                  type="text"
                  className="form-control bg-light"
                  {...register("lotId")}
                />
              </div>

              <div className=" col-12">
                <label>Lote</label>
                <input
                  readOnly={true}
                  type="text"
                  className="form-control bg-light"
                  {...register("lotName")}
                />
              </div>

              <div className=" col-12">
                <label>Número</label>
                <input
                  type="number"
                  className="form-control"
                  {...register("name")}
                />
              </div>

              <div className=" col-12">
                <label>&nbsp; </label>
                <button
                  className="btn btn-primary w-100"
                  type="button"
                  onClick={() => ingresarLinea()}
                >
                  <i className="bi bi-plus-square fa-lg m-2" /> Insertar Linea
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>


      <div className="col-12 col-sm-4">
        <div className="card p-4">
          <div className="card-title">
            <h4 className="text-secondary" >{linesCount}  líneas</h4>
            <div className=" bdr">
              <Spin spinning={loading}>
                <table className="table">
                  <thead className="table-primary">
                    <tr>
                      <th>Nombre</th>
                      <th>Pal/Max</th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    {listLines.map((line) => (
                      <tr key={line._id}>
                        <td>{line.name}</td>
                        <td>({line.palmCount}/{line.maxPalmNumber})</td>
                        <td style={{ width: "20px" }}>

                          <td className="text-center" style={{ width: "65px" }}>

                            <div className="dropdown">

                              <button
                                className="btn btn-light border"
                                type="button"
                                data-bs-toggle="dropdown"
                                aria-expanded="false"
                                title="Acciones del lote"
                              >
                                <i className="bi bi-three-dots-vertical"></i>
                              </button>

                              <ul className="dropdown-menu dropdown-menu-end shadow-sm">

                                <li>
                                  <button
                                    className="dropdown-item"
                                    onClick={() => getListByLine(line)}
                                  >
                                    <i className="bi bi-search me-2 text-primary"></i>
                                    Visualizar palmas
                                  </button>
                                </li>


                                <li>
                                  <button
                                    className="dropdown-item"
                                    onClick={() => addPalm(line)}
                                  >
                                    <i className="bi bi-tree  me-2 text-primary"></i>
                                    Editar palmas
                                  </button>
                                </li>





                                {sessionUser === "superadmin" && (
                                  <>
                                    <li><hr className="dropdown-divider" /></li>


                                    <li>
                                      <button
                                        className="dropdown-item text-danger"
                                        onClick={() => deleteLine(line._id, line.name)}
                                      >
                                        <i className="bi bi-trash me-2"></i>
                                        Eliminar linea
                                      </button>
                                    </li>
                                  </>
                                )}

                              </ul>

                            </div>

                          </td>








                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </Spin>
            </div>
          </div>
        </div>

      </div>





      <div className={showDivPalms ? "col-12 col-sm-5" : "d-none"}>
        <div className="card p-4">
          <div className="card-title">
            <h4 className="text-secondary" >Palmas línea {lineName}</h4>
            <div className=" bdr">
              <Spin spinning={loading}>
                <table className="table">
                  <thead className="table-primary">
                    <tr>
                      <th>Nombre</th>
                      <th>Latitud</th>
                      <th>Longitud</th>
                      <th>Labores</th>
                    </tr>
                  </thead>
                  <tbody>
                    {listPalms.map((palm) => (
                      <tr key={palm._id}>
                        <td>{palm.name}</td>
                        <td>{palm.latitude}</td>
                        <td>{palm.longitude}</td>
                        <td>
                          <button
                            className="btn btn-info ms-2"
                            onClick={() => getListByPalm(palm)}
                          >
                            <i className="bi bi-search fa-lg m-1" />
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </Spin>
            </div>
          </div>
        </div>
      </div>






      <Modal
        title={`Movimientos de la palma ${selectedPalm ? selectedPalm.name : ""}`}
        open={isModalOpen}
        onCancel={() => setIsModalOpen(false)}
        footer={null}
        width="60%"
      >

        <div className="row">

          <div className="col-12 col-sm-9">
            <Pagination
              className="text-primary mb-4 "
              current={page}
              pageSize={pageSize}
              total={total}
              onChange={handlePageChange}
              pageSizeOptions={["10", "20", "50"]}
              showTotal={(total) => `Total ${total} registros`}
              showSizeChanger
              onShowSizeChange={(current, size) => handlePageChange(1, size)}
            />

          </div>

          <div className="col-12 col-sm-3 d-none">
            <Spin spinning={loadingMovements}>
              <button
                className="btn btn-success w-100"
                type="button"
                onClick={() => generateExcel()}
              >
                <i className="bi bi-file-earmark-text fa-lg m-2" /> Exportar
              </button>
            </Spin>
          </div>


        </div>




        <Spin spinning={loadingMovements}>
          <table className="table">
            <thead className="table-primary">
              <tr>
                <th>Fecha</th>
                <th>Operario</th>
                <th>Primera</th>
                <th>Segunda</th>
                <th>Tercera</th>
                <th>Sin aplicación</th>
                <th>Total</th>
              </tr>
            </thead>
            <tbody>
              {movements.map((mov, index) => (
                <tr className={mov.totalWithoutApplication ? "table-danger" : ""} key={index}>
                  <td>{mov.date.split("T")[0]}</td>
                  <td>{mov.userName}</td>
                  <td>{mov.totalFirst}</td>
                  <td>{mov.totalSecond}</td>
                  <td>{mov.totalThird}</td>
                  <td>{mov.totalWithoutApplication}</td>
                  <td>{mov.total}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </Spin>
      </Modal>

    </div>
  );
};

export default AdminLines;
